import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=61aa72c3&"
import script from "./WorkDetail.vue?vue&type=script&lang=js&"
export * from "./WorkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports